import styled from 'styled-components';

export const Title = styled.div``;

export const Content = styled.div`
  font-size: 20px;
  position: relative;
  color: #fff;
  font-weight: 500;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .mr10 {
    margin-right: 10px;
  }
`;

export const CurrentMode = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: normal;
  margin-left: 10px;
  position: relative;
  span {
    color: #47b972;
    display: block;
    margin-left: 7px;
  }
  &.error span {
    color: #f00;
  }
`;

export const Explanation = styled.div`
  position: absolute;
  right: 0;
  bottom: -17px;
  color: #f00;
  text-align: right;
  white-space: nowrap;
`;
